export const SQL_KEYWORDS = [
  'SELECT',
  'FROM',
  'WHERE',
  'INSERT',
  'UPDATE',
  'DELETE',
  'CREATE',
  'DROP',
  'TABLE',
  'INDEX',
  'DATABASE',
  'ALTER',
  'ADD',
  'COLUMN',
  'PRIMARY',
  'KEY',
  'FOREIGN',
  'REFERENCES',
  'CONSTRAINT',
  'NOT',
  'NULL',
  'UNIQUE',
  'DEFAULT',
  'AUTO_INCREMENT',
  'IDENTITY',
  'CASCADE',
  'ON',
  'OFF',
  'SET',
  'VALUES',
  'INTO',
  'INNER',
  'LEFT',
  'RIGHT',
  'FULL',
  'OUTER',
  'JOIN',
  'UNION',
  'GROUP',
  'BY',
  'ORDER',
  'HAVING',
  'AS',
  'DISTINCT',
  'TOP',
  'LIMIT',
  'OFFSET',
  'CASE',
  'WHEN',
  'THEN',
  'ELSE',
  'END',
  'IF',
  'EXISTS',
  'IN',
  'BETWEEN',
  'LIKE',
  'IS',
  'AND',
  'OR',
  'COUNT',
  'SUM',
  'AVG',
  'MIN',
  'MAX',
  'SUBSTRING',
  'LENGTH',
  'UPPER',
  'LOWER',
  'TRIM',
  'GETDATE',
  'GETUTCDATE',
  'DATEADD',
  'DATEDIFF',
  'YEAR',
  'MONTH',
  'DAY',
  'CAST',
  'CONVERT',
  'ISNULL',
  'COALESCE',
  'NEWID',
  'GUID',
  'VARCHAR',
  'NVARCHAR',
  'INT',
  'BIGINT',
  'DECIMAL',
  'FLOAT',
  'BIT',
  'DATE',
  'DATETIME',
  'DATETIME2',
  'TIME',
  'TIMESTAMP'
];

export const SQL_FUNCTIONS = [
  'COUNT',
  'SUM',
  'AVG',
  'MIN',
  'MAX',
  'LEN',
  'SUBSTRING',
  'UPPER',
  'LOWER',
  'TRIM',
  'LTRIM',
  'RTRIM',
  'REPLACE',
  'CHARINDEX',
  'PATINDEX',
  'GETDATE',
  'GETUTCDATE',
  'DATEADD',
  'DATEDIFF',
  'YEAR',
  'MONTH',
  'DAY',
  'CAST',
  'CONVERT',
  'ISNULL',
  'COALESCE',
  'NULLIF',
  'IIF',
  'CHOOSE',
  'NEWID',
  'ROW_NUMBER',
  'RANK',
  'DENSE_RANK',
  'NTILE'
];
